import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Alert } from "react-bootstrap";
import MiniLoader from "../../../utilityComponents/MiniLoader";
import { fetchKpiStatusForAScenario } from "./../../../actions/KpiSummaryDashboardEnhanced/ExpandableKpiSummaryComponentAction";
import KpiStatusBarChart from "./KpiStatusBarChart";
import { resetDownloadGroundFiles } from "../../../actions/closeLoop/kpiDashboard/download/downloadReportsActions";

function ExpandableKpiSummaryComponent(props) {
    const [kpiStatus, setKpiStatus] = useState(false);
    const getKpiStatus = async () => {
        const payload = props.data.scenario_uuid;
        return await props.dispatch(fetchKpiStatusForAScenario(payload));
    };
    useEffect(() => {
        getKpiStatus()
            .then((res) => {
                setKpiStatus(res);
            })
            .catch((err) => {
                console.log("error:", err);
            });
    }, []);
    console.log(kpiStatus);
    return (
        <div>
            <div className="container-fluid">
                {!kpiStatus ? (
                    <MiniLoader />
                ) : props.error ? (
                    <Alert key="danger" variant="danger">
                        {props.error}
                    </Alert>
                ) : (
                    <KpiStatusBarChart kpiStatus={kpiStatus} />
                )}
            </div>
        </div>
    );
}

const mapStateToProps = (state) => ({
    loading: state.ExpandableKpiSummaryComponentData.loading,
    scenarioKpiStatus:
        state.ExpandableKpiSummaryComponentData.successSummaryScenarioKpiStatus,
    error: state.ExpandableKpiSummaryComponentData.error,
});

// const mapDispatchToProps = (dispatch) => ({
//     getKpiStatusForAScenario: (payload) =>
//         dispatch(fetchKpiStatusForAScenario(payload)),
// });

export default connect(
    mapStateToProps,
    undefined
    // mapDispatchToProps
)(ExpandableKpiSummaryComponent);
